import State from 'store/State';
import { RequestStatus } from './RequestProgressState';

export const selectRequestProgress = (state: State, key: string) =>
    state.requestProgress[key];

export const selectRequestIsPending = (state: State, key: string) => {
    const progress = selectRequestProgress(state, key);
    return !progress || progress.status === RequestStatus.NONE;
};
